var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-relation-card-collapsed',_vm._g({attrs:{"title":_vm.name,"draggable":"","icon":_vm.icon,"image":_vm.imageUrl}},_vm.$listeners),[_c('template',{slot:"actions"},[_vm._t("actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }